<template>
  <div>
    <FormSearchableSelect
      v-show="!loadingError"
      :options="priceRequestOptions"
      :value="value"
      @input="updateValue($event)"
      :placeholder="placeholder"
      :field="field"
      :note="note"
      :loading="loading"
      :appendToBody="true"
    />
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
  </div>
</template>

<script>
export default {
  name: 'PriceRequestSearchableSelect',
  model: {
    event: 'input'
  },
  props: {
    value: [Number, String],
    placeholder: {
      type: String,
      default: 'Price Request'
    },
    field: String,
    note: String,
    statusFilters: Array,
    typeFilters: Array,
    nullSelectionEnabled: {
      type: Boolean,
      default: false
    },
    nullSelectionName: {
      type: String,
      default: 'No Price Request'
    }
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      priceRequestLookup: []
    }
  },
  computed: {
    priceRequestOptions() {
      var requestList = []
      if(this.nullSelectionEnabled) {
        requestList.push({ value: null, name: this.nullSelectionName })
      }
      requestList = requestList.concat(this.priceRequestLookup)
      return requestList
    }
  },
  watch: {
    statusFilters: function() {
      this.requestData()
    },
    typeFilters: function() {
      this.requestData()
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true
      var params = {
        filter: {}
      }
      if(this.statusFilters && this.statusFilters.length)
        params.filter.status = this.statusFilters
      if(this.typeFilters && this.typeFilters.length)
        params.filter.type = this.typeFilters
      
      let queryString = $.param(params)

      this.$api.get(`/pricing/requests?${queryString}`)
      .then(response => {
        this.priceRequestLookup = response.data.map(item => {
          return {
            value: item.id,
            name: item.sequenceNumber,
            data: {
              id: item.id,
              type: item.type,
              status: item.status,
              sequenceNumber: item.sequenceNumber
            }
          }
        })
      })
      .catch(err => {
        this.loadingError = 'Error accessing data'
      })
      .finally(() => {
        this.loading = false
      })
    },
    updateValue(id) {
      this.$emit('input', id)

      // Update with extra info for the price request details
      let requestInfo = this.priceRequestLookup.find(request => request.value == id)
      if(!requestInfo) {
        this.$emit('updateRequestInfo', null)
      } else {
        this.$emit('updateRequestInfo', {
          id: id,
          sequenceNumber: requestInfo.data.sequenceNumber,
          type: requestInfo.data.type,
          status: requestInfo.data.status
        })
      }
    }
  }
}
</script>